<mat-form-field style="width: 80%">
  <mat-label>Search Customer *</mat-label>
  <input
    type="text"
    matInput
    [formControl]="assetCustName"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onSelectionChange($event)"
  >
    <mat-option *ngFor="let option of customerList | async" [value]="option">
      {{ option }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
